import React, {useEffect, useRef, ComponentPropsWithoutRef} from 'react';
import classnames from 'classnames';
import 'stylesheets/components/shared-textarea.scss';

export interface Props extends ComponentPropsWithoutRef<'textarea'> {
  className?: string;
  outerDivClassName?: string;
  error?: string;
  showMaxLength?: boolean;
}

const TextArea = ({
  className,
  outerDivClassName,
  error,
  showMaxLength,
  ...textAreaProps
}: Props) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const valueLength =
    (textAreaProps.value &&
      typeof textAreaProps.value !== 'number' &&
      textAreaProps.value.length) ||
    0;

  useEffect(() => {
    if (!ref.current) return;

    ref.current.style.height = 'auto';
    ref.current.style.height = `${ref.current.scrollHeight || 80}px`;
  }, [textAreaProps.value]);

  return (
    <div className={classnames('shared-textarea', outerDivClassName, {error})}>
      <textarea
        ref={ref}
        className={classnames('shared-textarea-input', className, {error})}
        data-testid="shared-textarea"
        {...textAreaProps}
      ></textarea>
      <div
        className={classnames({
          'shared-textarea-text-container': error && showMaxLength && textAreaProps.maxLength,
        })}
      >
        <div className="shared-textarea-error-message">{error}</div>
        {showMaxLength && textAreaProps.maxLength && (
          <div
            className={classnames('shared-textarea-character-count', {
              'shared-textarea-character-count-red': valueLength > textAreaProps.maxLength - 16,
            })}
          >
            {valueLength}/{textAreaProps.maxLength}
          </div>
        )}
      </div>
    </div>
  );
};

export default TextArea;
